module.exports = __webpack_public_path__ + "static/media/Vector.3cf89fc2.svg";